// import external dependencies
import 'jquery';
import '@fancyapps/fancybox';
import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import deLocale from '@fullcalendar/core/locales/de';

// Import everything from autoload
import './autoload/_bootstrap.js'

jQuery(document).ready(function($){
  $('[data-fancybox]').fancybox({
    buttons: [
      'zoom',
      //"share",
      'slideShow',
      //"fullScreen",
      //"download",
      //"thumbs",
      'close',
    ],
  });
  
  $('.toggle-menu').on('click', function(){
    $('.mobile-nav-wrapper').toggleClass('d-none d-md-block');
    $('.toggle-menu i').toggleClass('d-none');
  });
  
  $(window).scroll(function(){
    var logoOffset = $(document).scrollTop()*-1;
    $('.logo-desktop').css({ top: logoOffset });
  });

  var offset = -80;
  $('a[href*="#"]:not([href="#"])').on('click', function() {
    if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
      var target = $(this.hash.replace('#_', '#'));
      target = target.length ? target : $('[name=' + this.hash.slice(1) +']');

      if (target.length) {
        $('html, body').animate({
          scrollTop: target.offset().top + offset,
        }, 1000);
        return false;
      }
    }
  });

  function anchorOffset() {
    $('a[href*=#]').each(function () {
      $(this).attr('href', $(this).attr('href').replace('#', '#_'));
    });

    var hashname = window.location.hash.replace('#_', '');
    if(hashname){
      var elem = $('a[name="' + hashname + '"],#' + hashname);
  
      if(elem) {
        $('html, body').animate({
          scrollTop: elem.offset().top + offset,
        }, 1000);
      }
    }
  }
  anchorOffset();
  
  if($('#calendar1').length && $('#calendar2').length) {
    var calendarEl1 = document.getElementById('calendar1');
    var calendarEl2 = document.getElementById('calendar2');
    var calendar_events = $.parseJSON($('#calendar_dates').val());
  
    var calendar1 = new Calendar(calendarEl1, {
      plugins: [ dayGridPlugin ],
      header: {
        left: 'title',
        center: '',
        right: '',
      },
      aspectRatio: 1,
      locale: deLocale,
      events: calendar_events,
      eventBackgroundColor: $('#calendar_bg_color').val(),
      eventBorderColor: $('#calendar_bg_color').val(),
      eventTextColor: $('#calendar_text_color').val(),
      eventRender: function(event) {
        $(event.el).attr('data-toggle', 'tooltip').attr('data-placement', 'top').attr('title', event.event.title);
      },
    });
    
    var now = new Date();
    var nextMonth;
    if (now.getMonth() == 11) {
      nextMonth = new Date(now.getFullYear() + 1, 0, 1);
    } else {
      nextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1);
    }
    
    var calendar2 = new Calendar(calendarEl2, {
      defaultDate: nextMonth,
      plugins: [ dayGridPlugin ],
      header: {
        left: 'title',
        center: '',
        right: '',
      },
      aspectRatio: 1,
      locale: deLocale,
      events: calendar_events,
      eventBackgroundColor: $('#calendar_bg_color').val(),
      eventBorderColor: $('#calendar_bg_color').val(),
      eventTextColor: $('#calendar_text_color').val(),
      eventRender: function(event) {
        $(event.el).attr('data-toggle', 'tooltip').attr('data-placement', 'top').attr('title', event.event.title);
      },
    });
  
    calendar1.render();
    calendar2.render();
  }
  
  $('[data-toggle="tooltip"]').tooltip();
});



// WEBPACK FOOTER //
// ./scripts/main.js